import React from 'react';
import { Button,Spinner } from 'react-bootstrap'

//ICONOS
import DoneOutlinedIcon from '@material-ui/icons/DoneOutlined';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const Continuar = (props) => {
    const { tipo, spinner } = props;
    if (tipo && tipo === "guardar") {
        return (
            <>
                <Button className="ml-4 d-block d-sm-none" variant="success" size="sm" style={{ width: 115 }} type="submit"
                >
                    Continuar {spinner ? <Spinner animation="border" variant="light" size="sm" /> : <ArrowForwardIcon />}
                </Button>

                <Button className="ml-4 d-none d-sm-block" variant="success" size="sm" style={{ width: 180 }} type="submit"
                >
                    Guardar y Continuar {spinner ? <Spinner animation="border" variant="light" size="sm" /> : <ArrowForwardIcon />}
                </Button>
            </>
        )
    } else if (tipo && tipo === "continuar") {
        return (
            <Button className="ml-4" variant="success" size="sm" style={{ width: 115 }} type="submit"
            >
                Continuar {spinner ? <Spinner animation="border" variant="light" size="sm" /> : <ArrowForwardIcon />}
            </Button>
        )
    } else {
        return (
            <Button className="ml-4" variant="success" size="sm" style={{ width: 115 }} type="submit"
            >
                {spinner ? <Spinner animation="border" variant="light" size="sm" /> : <DoneOutlinedIcon />} Continuar
            </Button>
        )
    }
}

export default Continuar
